import { render, staticRenderFns } from "./LivePreview.vue?vue&type=template&id=a54ac4ea"
import script from "./LivePreview.vue?vue&type=script&lang=js"
export * from "./LivePreview.vue?vue&type=script&lang=js"
import style0 from "./LivePreview.vue?vue&type=style&index=0&id=a54ac4ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports